import { useState, useRef } from 'react';
import { LuUser } from "react-icons/lu";
import './Scandinavian.css'
import handleSubmit from './ScoreUpload';
import { useAlert } from 'react-alert';
const Scandinavian = ({ data }) => {
    const formRef = useRef(null);
    const alert = useAlert()
    const [loading, setLoading] = useState(false)
    const [scores, setScores] = useState({
        consciousness: null,
        eyeMovement: null,
        armMotorPower: null,
        handMotorPower: null,
        legMotorPower: null,
        orientation: null,
        speech: null,
        facialPalsy: null,
        gait: null
    });
    const [info, setInfo] = useState({
        therapy_consultation: data?.therapy_id || '',
        id: data?.id || '',
        name: data?.name || '',
        age: data?.age || '',
        gender: data?.gender || '',
        diagnosis: '',
        therapy_type: 'general'
    });
    const assessmentData = [
        {
            category: 'consciousness',
            label: 'Consciousness',
            options: [
                { text: 'Fully conscious', score: 6 },
                { text: 'Somnolent, but can be awakened to full consciousness', score: 4 },
                { text: 'Reacts to verbal command but is not fully conscious', score: 2 }
            ]
        },
        {
            category: 'eyeMovement',
            label: 'Eye movement',
            options: [
                { text: 'No gaze palsy', score: 4 },
                { text: 'Gaze palsy present', score: 2 },
                { text: 'Conjugate eye deviation', score: 0 }
            ]
        },
        {
            category: 'armMotorPower',
            label: 'Arm, motor power',
            options: [
                { text: 'Raises arm with normal strength', score: 6 },
                { text: 'Raises arm with reduced strength', score: 5 },
                { text: 'Raises arm with flexion in elbow', score: 4 },
                { text: 'Can move but not against gravity', score: 2 },
                { text: 'Paralysis', score: 0 }
            ]
        },
        {
            category: 'handMotorPower',
            label: 'Hand, motor power',
            options: [
                { text: 'Normal strength', score: 6 },
                { text: 'Reduced strength in full range', score: 4 },
                { text: 'Some movement, fingertips do not reach palm', score: 2 },
                { text: 'Paralysis', score: 0 }
            ]
        },
        {
            category: 'legMotorPower',
            label: 'Leg, motor power',
            options: [
                { text: 'Normal strength', score: 6 },
                { text: 'Raises straight leg with reduced strength', score: 5 },
                { text: 'Raises leg with flexion of knee', score: 4 },
                { text: 'Can move but not against gravity', score: 2 },
                { text: 'Paralysis', score: 0 }
            ]
        },
        {
            category: 'orientation',
            label: 'Orientation',
            options: [
                { text: 'Correct for time, place and person', score: 6 },
                { text: 'Two of these', score: 4 },
                { text: 'One of these', score: 2 },
                { text: 'Completely disorientated', score: 0 }
            ]
        },
        {
            category: 'speech',
            label: 'Speech',
            options: [
                { text: 'No aphasia', score: 10 },
                { text: 'Limited vocabulary or incoherent speech', score: 6 },
                { text: 'More than yes/no but no longer sentences', score: 3 },
                { text: 'Only yes/no or less', score: 0 }
            ]
        },
        {
            category: 'facialPalsy',
            label: 'Facial palsy',
            options: [
                { text: 'None / dubious', score: 2 },
                { text: 'Present', score: 0 }
            ]
        },
        {
            category: 'gait',
            label: 'Gait',
            options: [
                { text: 'Walks 5m without aids', score: 12 },
                { text: 'Walks with aids', score: 9 },
                { text: 'Walks with the help of another person', score: 6 },
                { text: 'Sits without support', score: 3 },
                { text: 'Bedridden / wheelchair', score: 0 }
            ]
        }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInfo(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleScoreChange = (category, score) => {
        setScores(prev => ({
            ...prev,
            [category]: score
        }));
    };

    const calculateTotalScore = () => {
        return Object.values(scores).reduce((total, score) => {
            return total + (score !== null ? score : 0);
        }, 0);
    };

    const totalScore = calculateTotalScore();

    const handleCancel = () => {
        setScores({
            consciousness: null,
            eyeMovement: null,
            armMotorPower: null,
            handMotorPower: null,
            legMotorPower: null,
            orientation: null,
            speech: null,
            facialPalsy: null,
            gait: null
        });
    }

    const handleFormSubmit = async () => {
        setLoading(true)
        const result = await handleSubmit(info, formRef, 'ss_scale', alert, totalScore);

        if (result && result.success) {
            handleCancel()
        }
        if (result) {
            setLoading(false)
        }
    };
    return (
        <>
            <div className="general-form-content" ref={formRef}>
                <div className="section-header">
                    <h2>SCANDINAVIAN SCORE SCALE</h2>
                </div>
                <div className="assessment-table">
                    <table className="scale-table">
                        <thead>
                            <tr>
                                <th>Assessment</th>
                                <th>Description</th>
                                <th>Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            {assessmentData?.map((item, index) => (
                                <tr key={index} className="assessment-row">
                                    <td className="category-cell">
                                        <strong>{item.label}</strong>
                                    </td>
                                    <td className="description-cell">
                                        <div className="options-container">
                                            {item.options.map((option, optIndex) => (
                                                <label key={optIndex} className="option-label">
                                                    <input
                                                        type="radio"
                                                        name={item.category}
                                                        value={option.score}
                                                        checked={scores[item.category] === option.score}
                                                        onChange={() => handleScoreChange(item.category, option.score)}
                                                    />
                                                    <span className="option-text">{option.text}</span>
                                                    <span className="option-score">{option.score}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </td>
                                    <td className="score-cell">
                                        <div className="current-score">
                                            {scores[item.category] !== null ? scores[item.category] : '-'}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="total-row">
                                <td><strong>TOTAL SCORE</strong></td>
                                <td className="max-score-note">(Maximal score is 58)</td>
                                <td className="total-score-cell">
                                    <div className="total-score-display">
                                        <strong>{totalScore}</strong>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div className="note-section">
                    <p className="assessment-note">
                        <strong>Note:</strong> Motor power is only assessed on the affected side.
                    </p>
                </div>
            </div>
            <div className="general-form-actions">
                <button type="button" onClick={handleCancel} className="cancel-btn">Cancel</button>
                <button type="submit" onClick={handleFormSubmit} disabled={loading} className="submit-btn" style={{ cursor: loading ? 'wait' : 'pointer' }} >{loading ? 'Saving...' : 'Save'}</button>
            </div>
        </>
    );
};

export default Scandinavian;